import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Checkbox, Grid, TextField, ThemeProvider, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import customtheme from '../../themes';
import { useSelector } from 'react-redux';
import RtlProvider from "../../Components/RtlProvider"
import './../../Styles/react-tagsinput.css'
import brokerGroupApi from "../../api/brokerGroupApi";
import { ContextNotification, severitys } from "../../App";
import BeatLoading from "../../Components/Loader/BeatLoader";
import FileInput from "../../Components/FileInput";

const AddTafvigFile = () => {
    const [submitLoading, setSubmitLoading] = useState(false);
    const { setOpen } = useContext(ContextNotification);
    const [fileForm,setFileForm]=useState(new FormData());
    const [hasFile,setHasFile]=useState(false);
    
    const customization = useSelector((state) => state.customization);
        const schema = yup.object().shape({
    
        });
        const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
    
            resolver: yupResolver(schema),
        });

    const resetForm=()=>{
       fileForm.delete('FormFile'); 
       setHasFile(false);
    }
    const refreshform=()=>{
      const fileinput = fileForm.get('FormFile')
      if(fileinput)
        setHasFile(true);
      else
      setHasFile(false);
    }
    const onSubmit = (data) => {        
         const fileinput = fileForm.get('FormFile')
         if(fileinput)
         {
          setSubmitLoading(true);
brokerGroupApi.AddTafvigFile(fileinput).then(res => {
               if (res.status === 200) {
                 setOpen({ IsEnable: true, Message: 'فایل با موفقیت ثبت شد', severity: severitys.success });
                 resetForm();
               }
               else {
                 setOpen({ IsEnable: true, Message: res.data.message ? res.data.message : 'خطا در عملیات', severity: severitys.error });
               }
         
             }).catch(err => {
         
               if (err.response && err.response.data) {
                 setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
               }
               else if (err.response && err.response.data && err.response.data.errors) {
                 setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
               }
               else if (err.message) {
                 setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
               }
         
             }).finally(() => { setSubmitLoading(false) });
         }
         else{
          setOpen({ IsEnable: true, Message: 'فایلی انتخاب نشده است', severity: severitys.error });
         }
         
    }
    return (
        <>
           <ThemeProvider theme={customtheme(customization)}>
                <RtlProvider>
                    <Typography component="h1" variant="h5" mb={2} >
                         بارگذاری فایل تفویج      </Typography>
                    <form onSubmit={handleSubmit(onSubmit)}>

                        <Grid container spacing={2}>
                                                    <Grid item size={{ xs: 3, sm: 3, md: 3, lg: 1, xl: 1 }}>
                            <FileInput formData={fileForm} refreshGrid={refreshform}/>
                        </Grid>
                        <Grid item md={4}>
                                      <Button type="submit" disabled={(submitLoading)||!(hasFile)} variant="contained" color="primary" fullWidth >
                                        <BeatLoading loading={submitLoading} color={"#e65100"} /> ثبت فایل </Button>
                                    </Grid>
                        </Grid>
                    </form>
                </RtlProvider>
            </ThemeProvider>
        </>
    )

}
export default AddTafvigFile